export const PESANS_GET = 'PESANS_GET';
export const STATUS_UPDATE = 'STATUS_UPDATE';
export const PESAN_DELETE = 'PESAN_DELETE';